const PaymentTypeEnum = {
  ONE_TIME: 'ONE_TIME',
  YEARLY: 'YEARLY',
  MONTHLY: 'MONTHLY',
  };

export default PaymentTypeEnum;